import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background-color":"var(--background-color-dark)"},
  class: "height-less-seventy-two"
}
const _hoisted_2 = {
  class: "search-section-background",
  style: {}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_section = _resolveComponent("header-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_header_section, { pinHeader: false }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "welcome-wrapper container-fluid" }, [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("h1", { class: "col-sm-12 col-md-8 offset-md-2 welcome-header text-light" }, " Don't Overpay On Your Prescriptions ")
        ])
      ], -1))
    ])
  ]))
}